var Buffer = require("buffer/").Buffer;
window.Buffer = Buffer;

import apiClient from "./api-client";
window.apiClient = apiClient;

let bcPromiseResolve = null;
let bcPromiseReject = null;
let bcPromise = new Promise(function(resolve, reject) {
  bcPromiseResolve = resolve;
  bcPromiseReject = reject;
});

/* Generic Helpers */
let self = {
  url: {
    fix: window.apiClient.fixUrl,
    parseQueryString(query) {
      query = query || window.location.href;
      if (!query) {
        return { };
      }
    
      return (/[?]/.test(query) ? query.split('?')[1] : query)
        .split('&')
        .reduce((params, param) => {
          let [ key, value ] = param.split('=');
          params[key] = value ? self.url.decode(value.replace(/\+/g, ' ')) : '';
          return params;
        }, { });
    },
    getQueryString(query) {
      query = query || window.location.href;
      if (!query) {
        return '?';
      }
      return '?' + (/[?]/.test(query) ? query.split('?')[1] : query);
    },
    getBaseUrl(url) {
      url = url || window.location.href;
      if (!url) {
        return window.location.href;
      }
      return (/[?]/.test(url) ? url.split('?')[0] : url);
    },
    encode(value) {
      if (value) {
        let encoded = window.encodeURI(value);
        encoded = self.url.replace(encoded, '?', '%3F');
        encoded = self.url.replace(encoded, '/', '%2F');
        encoded = self.url.replace(encoded, '#', '%23');
        return encoded;
      }
      return value;
    },
    decode(value) {
      if (value) {
        let decoded = window.decodeURI(value);
        decoded = self.url.replace(decoded, '%3F', '?');
        decoded = self.url.replace(decoded, '%2F', '/');
        decoded = self.url.replace(decoded, '%23', '#');
        return decoded;
      }
      return value;
    },
    replace(value, oldToken, newToken) {
      return self.text.replace(value, oldToken, newToken);
    },
  },
  fileName: {
    stripIllegalChars(value, keepWhiteSpace, keepCase) {
      let illegalChars = [ '*', '"', '/', '\\', '[', ']', ':', ';', '|', ',' ];
      if (!keepWhiteSpace) {
        illegalChars.push(' ');
        illegalChars.push('\n');
        illegalChars.push('\t');
      }
      let retvalue = value;
      illegalChars.forEach((illegalChar) => {
        retvalue = self.text.replace(retvalue, illegalChar, '');
      });
      return !keepCase ? retvalue.toLowerCase() : retvalue;
    }
  },
  base64: {
    encode(string, encoding) {
      return escape(Buffer.from(string, encoding || 'utf8').toString('base64'));
    },
    decode(string, encoding) {
      return Buffer.from(unescape(string), 'base64').toString(encoding || 'utf8');
    },
    unescape (str) {
      return (str + '==='.slice((str.length + 3) % 4))
        .replace(/-/g, '+')
        .replace(/_/g, '/')
    },
    escape (str) {
      return str.replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '')
    },
  },
  object: {
    strip(object) {
      let newObject = Object.assign({}, object);
      for (let objectKey in newObject) {
        if (newObject[objectKey] === null) {
          delete newObject[objectKey];
        }
      }
      return newObject;
    },
    unstrip(strippedObject, fullObject, useFullObjectAsDefaults) {
      let newObject = { };
      for (let fullKey in fullObject) {
        newObject[fullKey] = typeof strippedObject[fullKey] === "undefined" ? (useFullObjectAsDefaults ? fullObject[fullKey] : null) : strippedObject[fullKey];
      }
      return newObject;
    }
  },
  text: {
    replace(value, oldToken, newToken) {
      let newValue = (value || '').toString();
      while (newValue.indexOf(oldToken) >= 0) {
        newValue = newValue.replace(oldToken, newToken);
      }
      return newValue;
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    padRight(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : n + new Array(width - n.length + 1).join(z);
    }
  },
  xsrf: {
    config() {
      let xsrfToken = window.appState.xsrfToken;
      if (xsrfToken) {
        Vue.http.headers.common['xsrf-form-token'] = xsrfToken;
      }
    }
  },
  tracker: {
    config() {
      let version = window.appState.version;
      if (version) {
        Vue.http.headers.common['app-web-version'] = version;
      }
    }
  },
  security: {
    hasPermission(entity, permission, tenantId) {
      if (!tenantId && !tenantId !== 0) {
        tenantId = window.appState.currentTenantId;
      }
      return !!window.appState.privileges.find((priv) => {
        return priv.entity === entity.toLowerCase() && priv.permissions[permission.toLowerCase()] && priv.tenants[tenantId];
      });
    }, 
    isModuleVisible(module) {
      return !window.appState.hiddenModules[module.toLowerCase()];
    },
    hasFunctionLock(code) {
      return !!window.appState.functionLocks[code];
    }
  },
  token: {
    setupAutoRefresh(postCheck) { 
      return new Promise(function(resolve, reject) {
        self.token.refreshCheck(resolve, reject, postCheck);
      });
    },
    refreshCheck(resolve, reject, postCheck) {
      if (window.appState.tokenExpiresMilliseconds > 90000)
      {
        window.setTimeout(() => { self.token.refresh(resolve, reject, postCheck); }, window.appState.tokenExpiresMilliseconds - 90000);
      }
      else
      {
        self.token.refresh(resolve, reject, postCheck);
      }
    },
    refresh(resolve, reject, postCheck) {
      //Check to see if a refresh is still required (applies in the event the user has multiple tabs open)
      apiClient.state.isAuthorized(window.appState.currentTenantId).then(authResponse => {
        self.token.postAuth(authResponse, postCheck);
        if (window.appState.tokenExpiresMilliseconds <= 90000) {
          apiClient.token.refresh().then(refreshResponse => {
            window.appState.tokenExpires = refreshResponse.body['expires'];
            window.appState.tokenExpiresMilliseconds = refreshResponse.body['expires_in_milliseconds'];
            window.appState.xsrfToken = authResponse.body.xsrfToken;
            self.token.refreshCheck(resolve, reject, postCheck);
          }, () => {
            //Recheck Auth status in case user has multiple tabs competing for the one-time refresh allowance
            window.setTimeout(() => {
              apiClient.state.isAuthorized(window.appState.currentTenantId).then(authResponse2 => {
                self.token.postAuth(authResponse2, postCheck);
                self.token.refreshCheck(resolve, reject, postCheck);
              }, () => {
                reject();
              });
            }, 500);
          });
        } else {
          self.token.refreshCheck(resolve, reject, postCheck);
        }
      }, () => {
        //Recheck Auth status in case user has multiple tabs competing for the one-time refresh allowance
        window.setTimeout(() => {
          apiClient.state.isAuthorized(window.appState.currentTenantId).then(authResponse2 => {
            self.token.postAuth(authResponse2, postCheck);
            self.token.refreshCheck(resolve, reject, postCheck);
          }, () => {
            reject();
          });
        }, 500);
      });
    },
    postAuth(authResponse, postCheck) {
      window.appState.tokenExpires = authResponse.body.tokenExpires;
      window.appState.tokenExpiresMilliseconds = authResponse.body.tokenExpiresMilliseconds;
      window.appState.xsrfToken = authResponse.body.xsrfToken;
      window.appState.currentTenantHostStatus = authResponse.body.currentTenantHostStatus;
      if (postCheck) {
        postCheck(authResponse.body);
      }
    }
  },
  message: {
    getFromResponse(response, defaultVariant) {
      if (typeof response.body !== 'undefined' && response.body !== null) {
        let errors = [];
        defaultVariant = defaultVariant || 'danger';
        if (Array.isArray(response.body)) {
          errors = response.body;
        } else if(response.body.errors && Array.isArray(response.body.errors)) {
          errors = response.body.errors;
        } else if(response.body.messages && Array.isArray(response.body.messages)) {
          errors = response.body.messages;
        } else {
          errors = [ `An HTTP ${response.status} error prevented this operation from completing` ];
        }
        return errors.map(error => {
          if (error.text) {
            return self.message.create(error.text, error.variant || defaultVariant)
          } else {
            return self.message.create(error, defaultVariant);
          }
        });
      } else if (Array.isArray(response)) {
        let messages = [];
        response.forEach((r) => {
          messages = messages.concat(self.message.getFromResponse(r, defaultVariant))
        });
        return messages;
      } else if (typeof response === 'object') {
        throw response;
      }
    },
    create(text, variant, dismissable, countdown) {
      let ret = {
        text: text,
        variant: variant || 'danger',
        dismissable: (typeof(dismissable) === 'boolean' ? dismissable : true)
      };
      if (countdown) {
        ret.countdown = countdown;
      }
      return ret;
    }
  },
  loader: {
    listeners: [],
    currentCounter: 0,
    register(listener) {
      self.loader.listeners.push(listener);
    },
    start() {
      self.loader.currentCounter++;
      self.loader.notify();
    },
    stop() {
      self.loader.currentCounter--;
      self.loader.notify();
    },
    notify() {
      self.loader.listeners.forEach((listener) => {
        listener(!!self.loader.currentCounter);
      });
    }
  },
  form: {
    isDirty: false,
    resetDirty() {
      self.form.isDirty = false;
    },
    markDirty() {
      self.form.isDirty = true;
    },
    routeCheckDirty(to, from, next, routes) {
      let postCheck = function(proceedFlag) {
        if (proceedFlag) {
          appHelpers.form.resetDirty();
          appHelpers.breadCrumbs.buildFromRoute(to, from, routes);
        }
        next(proceedFlag);
      };
      if (!appHelpers.form.isDirty) {
        postCheck(true);
      } else {
        return window.spa.$refs.confirm.confirm('You have unsaved changes on this form that will be lost if you proceed. Okay?').then(() => {
          postCheck(true);
        }, () => {
          postCheck(false);
        });
      }
    },
    hrefCheckDirty(e) {
      if (e.target && e.target.href) {
        self.form.urlCheckDirty(e.target.href, e);
      }
    },
    urlCheckDirty(url, e) {
      if (url && self.form.isDirty) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }
        return window.spa.$refs.confirm.confirm('You have unsaved changes on this form that will be lost if you proceed. Okay?').then(() => {
          window.location = url;
        }, () => {});
      } else if (url && !e) {
        window.location = url;
      }
    }
  },
  breadCrumbs: {
    initFlag: false,
    initPromiseResolve: bcPromiseResolve,
    initPromiseReject: bcPromiseReject,
    initPromise: bcPromise,
    current: [],
    base: [],
    all: [],
    init(crumbs) {
      if (!this.initFlag) {
        self.breadCrumbs.base.splice(0, self.breadCrumbs.base.length);
        if (Array.isArray(crumbs)) {
          crumbs.forEach((crumb) => {
            self.breadCrumbs.base.push(crumb);
          });
        } else {
          self.breadCrumbs.base.push(crumbs);
        }
        self.breadCrumbs.sync();
        this.initFlag = true;
        self.breadCrumbs.initPromiseResolve();
      }
    },
    clear() {
      self.breadCrumbs.current.splice(0, self.breadCrumbs.current.length);
      self.breadCrumbs.sync();
    },
    push(crumbs, clearFlag, baseFlag) {
      let target = baseFlag ? self.breadCrumbs.base : self.breadCrumbs.current;
      if (clearFlag) {
        target.splice(0, target.length);
      }
      if (Array.isArray(crumbs)) {
        crumbs.forEach((crumb) => {
          target.push(crumb);
        });
      } else {
        target.push(crumbs);
      }
      self.breadCrumbs.sync();
    },
    sync() {
      self.breadCrumbs.all.splice(0, self.breadCrumbs.all.length);
      self.breadCrumbs.base.forEach((crumb, index, array) => {
        crumb.active = !self.breadCrumbs.current.length ? (index === (array.length - 1)) : false;
        self.breadCrumbs.all.push(crumb);
      });
      self.breadCrumbs.current.forEach((crumb, index, array) => {
        crumb.active = (index === (array.length - 1));
        self.breadCrumbs.all.push(crumb);
      });
    },
    buildFromRoute(to, from, routes) {
      let pathParts = to.matched[0].path.split('/');
      let currentPath = '';
      let breadCrumbs = [];
      let pageTitle = window.appState.title;
      pathParts.forEach((pathPart, index, array) => {
        let myParamValue = null;
        let myParamCount = 0;
        if (index === 0 || pathPart !== '') {
          if (!currentPath.endsWith('/')) {
            currentPath += '/';
          }
          var paramStart = pathPart.indexOf(':');
          while (paramStart >= 0) {
            var paramEnd = pathPart.indexOf('--', paramStart + 1);
            let paramName = (paramEnd >= 0 ? pathPart.substring(paramStart + 1, paramEnd) : pathPart.substring(paramStart + 1));
            if (to.params[paramName]) {
              if (!myParamValue) {
                myParamValue = self.url.decode(to.params[paramName]);
              } else {
                myParamValue += ' ' + self.url.decode(to.params[paramName]);
              }
              myParamCount++;
              paramStart = pathPart.indexOf(':', paramEnd >= 0 ? paramEnd : paramStart + 1);
            }
          }
          currentPath += pathPart;
          let route = routes.find((route) => {
            return route.path === currentPath;
          });
          if (route) {
            let breadCrumbPath = currentPath;
            for (let paramKey in to.params) {
              breadCrumbPath = breadCrumbPath.replace(':' + paramKey, to.params[paramKey]);
            }
            let crumbText = (route.caption || route.name) + (myParamValue ? ` ${myParamValue}` : '');
            if (myParamCount === 1 && parseInt(myParamValue)) {
              crumbText = (route.caption || route.name) + (myParamValue ? ` #${myParamValue}` : '');
            }
            breadCrumbs.push({ text: crumbText, to: breadCrumbPath });
            pageTitle += " - " + crumbText;
          }
        }
      });
      self.breadCrumbs.initPromise.then(() => {
        self.breadCrumbs.push(breadCrumbs, true);
        document.title = pageTitle;
      });
    }
  },
  formatters: {
    formatDate (value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm') : 'N/A';
    },
    formatDateSansTime (value) {
      return value ? dayjs(value).format('YYYY-MM-DD') : 'N/A';
    },
    formatDateSansTimeShort (value) {
      return value ? dayjs(value).format('MM/DD/YY') : 'N/A';
    },
    formatDateWithSeconds (value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : 'N/A';
    },
    formatTime (value) {
      return value ? dayjs(value).format('HH:mm') : 'N/A';
    },
    formatTimeWithSeconds (value) {
      return value ? dayjs(value).format('HH:mm:ss') : 'N/A';
    },
    formatDateTime (value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm') : 'N/A';
    },
    formatCurrency (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      return formatter.format(typeof value == "number" ? value : parseFloat(value));
    },
    formatCurrencyInt (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(typeof value == "number" ? value : parseFloat(value));
    },
    formatCurrencyExtreme (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 4
      });
      return formatter.format(typeof value == "number" ? value : parseFloat(value));
    },
    formatShortFloat (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(1);
    },
    formatFloat (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(2);
    },
    formatFloatFancy(value, decimalPlaces = 2) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }

      if (isNaN(decimalPlaces)) {
          decimalPlaces = 2;
      }
      
      return (typeof value == "number" ? value : parseFloat(value)).toLocaleString(undefined, {maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces });
    },
    formatPreciseFloat (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(4);
    },
    formatPreciseFloatFancy(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toLocaleString(undefined, {maximumFractionDigits: 4, minimumFractionDigits: 4 });
    },
    formatInsaneFloat (value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(6);
    },
    formatInsaneFloatFancy(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toLocaleString(undefined, {maximumFractionDigits: 6, minimumFractionDigits: 6 });
    },
    formatPercent(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(1) + '%';
    },
    formatPercentExtended(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(2) + '%';
    },
    formatPercentExtreme(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(4) + '%';
    },
    formatInt(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toFixed(0);
    },
    formatIntFancy(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      return (typeof value == "number" ? value : parseFloat(value)).toLocaleString(undefined, {maximumFractionDigits: 0 });
    },
    formatIntNoRounding(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      let valueString = (typeof value == "number" ? value : parseFloat(value)).toFixed(2);
      return valueString.slice(0, valueString.indexOf('.'));
    },
    formatIntNoRoundingFancy(value) {
      if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value ? value : '';
      }
      let valueString = (typeof value == "number" ? value : parseFloat(value)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2 });
      return valueString.slice(0, valueString.indexOf('.'));
    },
    formatBool(value) {
      if (value) {
        return "Y";
      } else {
        return "N";
      }
    },
    trimString(value, length) {
      if (typeof value !== "string") {
        return value;
      }
      return value.substring(0, length);
    },
  },
  drawings: {
    getLink(drawingNumber) {
      if (drawingNumber && drawingNumber.length && window.appState.enableDrawingLinkFlag && window.appState.drawingLinkPathStructure)
      {
        let pathPrefix = '';
        if (drawingNumber.toUpperCase().indexOf('SMUB') === 0)
        {
          pathPrefix = 'B-DWG/BOLTLESS/PARTS';
        } else {
          pathPrefix = '{0}-DWG/{1}000';
        }
        let drawingNumberLink = window.appState.drawingLinkPathStructure;
        drawingNumberLink = self.text.replace(drawingNumberLink, '{3}', pathPrefix);
        drawingNumberLink = self.text.replace(drawingNumberLink, '{2}', drawingNumber);
        drawingNumberLink = self.text.replace(drawingNumberLink, '{1}', drawingNumber.substring(0, 5));
        drawingNumberLink = self.text.replace(drawingNumberLink, '{0}', drawingNumber.substring(0, 1));
        drawingNumberLink = self.text.replace(drawingNumberLink, '{user}', window.appState.userName);
        return drawingNumberLink;
      }
      return null;
    }
  },
  window: {
    mobileBreakPoint: 992,
    width() {
      return window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    },
    height() {
      return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
    isMobile(width) {
      return ((width || self.window.width()) <= self.window.mobileBreakPoint);
    },
  },
  filters: {
    load(storageKey, target) {
      let storageString = sessionStorage.getItem(storageKey);
      if (storageString) {
        let savedFilters = JSON.parse(storageString);
        return Object.assign({}, target, savedFilters);
      }
      return Object.assign({}, target);
    },
    save(storageKey, source) {
      let storageString = JSON.stringify(source);
      sessionStorage.removeItem(storageKey);
      sessionStorage.setItem(storageKey, storageString);
    },
    loadPerm(storageKey, target) {
      let storageString = localStorage.getItem(storageKey);
      if (storageString) {
        let savedFilters = JSON.parse(storageString);
        return Object.assign({}, target, savedFilters);
      }
      return Object.assign({}, target);
    },
    savePerm(storageKey, source) {
      let storageString = JSON.stringify(source);
      localStorage.removeItem(storageKey);
      localStorage.setItem(storageKey, storageString);
    },
  },
  table: {
    tempFieldToggles: {
    },
    getFieldToggles(tableKey, tenantId, tableId) {
      if (tableKey) {
        let storageKey = `${tableKey}-hidden-fields-${tenantId}`;
        let storageString = localStorage.getItem(storageKey);
        if (storageString) {
          let output = JSON.parse(storageString);
          if (output && !output.version) {
            output = {
              version: 2,
              hidden: (output.hidden || output) || { },
              visible: (output.visible || { }),
              order: (output.order || [ ])
            }
          }
          if (output && output.version && output.version === 1) {
            output.order = [ ];
            output.version = 2;
          }
          return output;
        } else {
          return {
            version: 2,
            hidden: { },
            visible: { },
            order: [ ]
          };
        }
      } else {
        return Object.assign({
          version: 2,
          hidden: { },
          visible: { },
          order: [ ]
        }, self.table.tempFieldToggles[tableId]);
      }
    },
    setFieldToggles(tableKey, tenantId, tableId, fieldToggles) {
      if (tableKey) {
        let storageKey = `${tableKey}-hidden-fields-${tenantId}`;
        let storageString = JSON.stringify(fieldToggles);
        localStorage.setItem(storageKey, storageString);
      } else {
        self.table.tempFieldToggles[tableId] = Object.assign({}, fieldToggles);
      }
    },
    resetFieldToggles(tableKey, tenantId, tableId) {
      if (!tableKey) {
        self.table.tempFieldToggles[tableId] = {
          version: 2,
          hidden: { },
          visible: { },
          order: [ ]
        };
      }
    }
  },
  lookup: {
    getDefault(list, name, value, id) {
      let defaultNameId = null;
      let defaultValueId = null;
      let defaultIdId = null;
      let defaultFirstId = null;
      if (list && list.length) {
        for (let listIndex in list) {
          var listItem = list[listIndex];
          if (name && listItem.name == name) {
            defaultNameId = listItem.id;
          }
          if (value && listItem.value == value) {
            defaultValueId = listItem.id;
          }
          if (id && listItem.id == id) {
            defaultIdId = listItem.id;
          }
          if (!defaultFirstId) {
            defaultFirstId = listItem.id;
          }
        }
      }
      return defaultNameId || defaultValueId || defaultIdId || defaultFirstId;
    },
    addCurrentByValue(list, value) {
      if (value && list && list.length) {
        let currentListItem = null;
        for (let listIndex in list) {
          let listItem = list[listIndex];
          if (parseFloat(listItem.value) === parseFloat(value)) {
            currentListItem = listItem;
          }
        }
        if (!currentListItem || !currentListItem.id) {
          list.push({ id: null, name: value.toString(), value: value});
        }
      }
      return list;
    },
    getHostDefault(list, code, description, descriptionStatus) {
      let defaultCodeCode = null;
      let defaultDescriptionCode = null;
      let defaultFirstCode = null;
      if (list && list.length) {
        for (let listIndex in list) {
          var listItem = list[listIndex];
          if (code && listItem.TABLE_DERIVED_CODE_TL == code) {
            defaultCodeCode = listItem.TABLE_DERIVED_CODE_TL;
          }
          if (description && listItem.TABLE_DESCRIPT_TL == description && (!descriptionStatus || listItem.TABLE_STATUS_TL == descriptionStatus)) {
            defaultDescriptionCode = listItem.TABLE_DERIVED_CODE_TL;
          }
          if (!defaultFirstCode) {
            defaultFirstCode = listItem.TABLE_DERIVED_CODE_TL;
          }
        }
      }
      return defaultCodeCode || defaultDescriptionCode || defaultFirstCode;
    }
  },
  audit: {
    logModule(module) {
      apiClient.audit.log(appState.currentTenantId, 'Accessed Module', module, null, appHelpers.url.getBaseUrl());
    },
    logScreen(module, screen) {
      apiClient.audit.log(appState.currentTenantId, 'Accessed Screen', module, screen, appHelpers.url.getBaseUrl());
    },
    logSearch(tableKey, exportKey) {
      apiClient.audit.log(appState.currentTenantId, `Queried Data for Table ${tableKey || exportKey || ''}`, null, null, appHelpers.url.getBaseUrl());
    },
    logExport(tableKey, exportKey) {
      apiClient.audit.log(appState.currentTenantId, `Exported Data from Table ${tableKey || exportKey || ''}`, null, null, appHelpers.url.getBaseUrl());
    },
    logEntityAction(action, entity, recordId, hideWithIdText, field) {
      if (!hideWithIdText) {
        apiClient.audit.log(appState.currentTenantId, `${action} ${entity} entity ${recordId ? `with id ${recordId}` : ''}`, null, null, appHelpers.url.getBaseUrl(), field);
      } else {
        apiClient.audit.log(appState.currentTenantId, `${action} ${entity} entity ${recordId ? ` ${recordId}` : ''}`, null, null, appHelpers.url.getBaseUrl(), field);
      }
    },
  },
  landing: {
    getDetailMode() {
      let storageKey = `landing-detail-mode`;
      return !!localStorage.getItem(storageKey);
    },
    setDetailMode(value) {
      let storageKey = `landing-detail-mode`;
      if (!value) {
        localStorage.removeItem(storageKey);
      } else {
        localStorage.setItem(storageKey, 'true');
      }
    }
  }
};

export default self;